<template>
  <div>
    <BaseModal
      :is-active="isModalActive"
      class="checkout-modal"
      :hide-close-button="hideCloseButton"
      :close-on-backdrop-click="closeOnBackdropClick"
      full-screen-until-m
      @close="$emit('input', $event)"
    >
      <template v-slot:header-content>
        <span class="checkout-modal__title">
          <slot name="title"></slot>
        </span>
      </template>

      <template v-slot:header-close-btn-label>
        <span class="base-modal__close-btn-label">
          &nbsp;<slot name="title"></slot>
        </span>
        <span class="checkout-modal__close-btn-icon"></span>
      </template>

      <template v-slot:body>
        <slot name="body"></slot>
      </template>

      <template v-slot:action-toolbar>
        <slot name="action-toolbar"></slot>
      </template>

      <slot></slot>
    </BaseModal>
  </div>
</template>

<script>
import Modal from '../../mixins/Modal';
import BaseModal from '../BaseModal';

export default {
  name: 'CheckoutModal',
  components: {
    BaseModal,
  },
  mixins: [Modal],
  model: {
    prop: 'isModalActive',
    event: 'input',
  },
  props: {
    isModalActive: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
